import { AppEnvironment } from '../../app/models/environment/app-environment.type';
import { buildConfig } from '../build/build-config';

export const environment: AppEnvironment = {
  ...buildConfig,
  name: 'dev',
  production: false,
  runtimeConfigPath: 'config.json',
  hasMyAccountIntegration: true,
  hasPlanSelection: true,
  hasAuthGuard: true,
  brandKey: 'smartfix',
  brandConfig: {
    title: 'SmartFix Hub',
    logo: {
      alt: 'Domestic & General Logo',
      aspectRatio: '16:9',
      src: 'assets/domestic-and-general.png',
    },
  },
};
